import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/bg.mp4'
import _imports_1 from '../assets/bg.mp3'


const _withScopeId = n => (_pushScopeId("data-v-d3e6ce74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "header",
  id: "top"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  autoplay: "",
  loop: "",
  muted: "",
  playsinline: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1))
const _hoisted_4 = { class: "greeting" }
const _hoisted_5 = { style: {"margin-top":"10vh","width":"50%","text-align":"center"} }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg class=\"WaveMultiGroup\" viewBox=\"0 24 150 28\" preserveAspectRatio=\"none\" shape-rendering=\"auto\" data-v-d3e6ce74><path fill=\"rgba(255,255,255,0.7)\" d=\"M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z\" data-v-d3e6ce74></path><path fill=\"rgba(255,255,255,0.5)\" d=\"M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z\" data-v-d3e6ce74></path><path fill=\"rgba(255,255,255,0.3)\" d=\"M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z\" data-v-d3e6ce74></path><path fill=\"rgba(255,255,255,1)\" d=\"M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z\" data-v-d3e6ce74></path></svg>", 1)
const _hoisted_7 = { class: "footprint-div" }
const _hoisted_8 = {
  class: "title",
  id: "footprint"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "linear-gradient-text" }, "👣 足 迹 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { style: {"margin":"10vh 10vw"} }
const _hoisted_13 = {
  class: "title",
  id: "collection"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "linear-gradient-text" }, "🌸 撷 英 ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { style: {"margin":"10vh 10vw"} }
const _hoisted_18 = {
  class: "title",
  id: "writing"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "linear-gradient-text" }, "💡 省 思 ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = ["href"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { style: {"padding-bottom":"14px","text-align":"center"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_1,
  type: "audio/mpeg"
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]

import SideMenu from "@/components/SideMenu.vue";
import TimeLine from "@/components/TimeLine.vue";
import ShowCase from "@/components/ShowCase.vue";
import { onMounted, onUnmounted, ref } from "vue";
import TypeIt from "typeit";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const text = ref("");
const title1 = ref("");
const title2 = ref("");
const title3 = ref("");
const isVisible = ref(true);
let timeoutId: number | null | undefined = null;

const hideMenu = () => {
  isVisible.value = false;
};

const showMenu = () => {
  isVisible.value = true;
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(hideMenu, 5000);
};

const handleScroll = () => {
  showMenu();
};
const blogContent = [
  {
    picPath: require("../assets/suzime.jpeg"),
    text: "荧幕后的万千世界",
    turnRoute: "https://v6bn1welpm.feishu.cn/docx/Dh2cdd1iOoLvzhxnJJBcq4XqnDI",
  },
  {
    picPath: require("../assets/atk.jpg"),
    text: "人类从历史中学到的",
    turnRoute: "https://www.bilibili.com/video/BV1494y1e7bV",
  },
  {
    picPath: require("../assets/cover.png"),
    text: "Research Page",
    turnRoute: "#/research",
  },
];
onMounted(() => {
  new TypeIt(text.value, {
    speed: 150,
    deleteSpeed: 50,
    cursorChar: "<span class='cursorChar'>|<span>", //用于光标的字符。HTML也可以
    lifeLike: true, // 使打字速度不规则
    cursor: false, //在字符串末尾显示闪烁的光标
    breakLines: false, // 控制是将多个字符串打印在彼此之上，还是删除这些字符串并相互替换
    loop: true, //是否循环
  })
    .type("欢迎来到邵国诚的个人网站！", { delay: 2000 })
    .delete("", { delay: 1000 })
    .type("点击任意位置以启用背景音乐~", { delay: 2000 })
    .delete("", { delay: 12000 })
    .go();

  new TypeIt(title1.value, {
    speed: 150,
    deleteSpeed: 50,
    lifeLike: true,
    loop: true,
  })
    .type("旅程总有一天会迎来终点，所以，不必匆忙", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type("风带来故事的种子，时间使之发芽", { delay: 5000 })
    .delete("", { delay: 2000 })
    .go();

  new TypeIt(title2.value, {
    speed: 150,
    deleteSpeed: 50,
    lifeLike: true,
    loop: true,
  })
    .type("旅人将遍历的一万个故事，都将成为旅人灵魂的一部分", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type("所谓的平凡生活，其实是日复一日的奇迹", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type(
      "就算命运是注定的，人在路途中能做的事仍然有很多，而故事的结局也会呈现截然不同的意义",
      { delay: 5000 }
    )
    .delete("", { delay: 2000 })
    .type("岁月流转，唯有思念与归风不变", { delay: 5000 })
    .delete("", { delay: 2000 })
    .go();

  new TypeIt(title3.value, {
    speed: 150,
    deleteSpeed: 50,
    lifeLike: true,
    loop: true,
  })
    .type("艺术，让人成为人", { delay: 5000 })
    .delete("", { delay: 2000 })
    .type("信息熵即为灵魂", { delay: 5000 })
    .delete("", { delay: 2000 })
    .go();
});

const bgaudio = ref();
const playAudio = () => {
  if (bgaudio.value && bgaudio.value.paused) {
    bgaudio.value.play();
  }
};

const writingSpan = ref(6);

const updateWritingSpan = () => {
  if (window.innerWidth <= 768) {
    writingSpan.value = 20;
  } else {
    writingSpan.value = 6;
  }
};
onMounted(() => {
  // 目前许多浏览器不允许自动播放音频，只有用户点击屏幕后才可以播放
  document.addEventListener("click", playAudio);
  window.addEventListener("scroll", handleScroll);
  updateWritingSpan();
  window.addEventListener("resize", updateWritingSpan);
});

onUnmounted(() => {
  document.removeEventListener("click", playAudio);
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", updateWritingSpan);
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", {
            ref_key: "text",
            ref: text,
            class: "msg"
          }, null, 512)
        ])
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ hidden: !isVisible.value }, "side-menu-div"])
    }, [
      _createVNode(SideMenu)
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("label", {
          class: "desc",
          ref_key: "title1",
          ref: title1
        }, null, 512)
      ]),
      _createVNode(TimeLine)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("label", {
          class: "desc",
          ref_key: "title2",
          ref: title2
        }, null, 512)
      ]),
      _createVNode(ShowCase)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _hoisted_21,
        _createElementVNode("label", {
          class: "desc",
          ref_key: "title3",
          ref: title3
        }, null, 512)
      ]),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(blogContent, (item, index) => {
            return _createVNode(_component_el_col, {
              key: item,
              span: writingSpan.value,
              offset: writingSpan.value === 6 ? (index % 3 !== 0 ? 1 : 2) : 2
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: item.turnRoute,
                  target: "_blank",
                  style: {"text-decoration":"none"}
                }, [
                  _createVNode(_component_el_card, {
                    shadow: "hover",
                    "body-style": { padding: '5px' },
                    style: {"margin-bottom":"5vh"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: item.picPath,
                        class: "image",
                        alt: item.text
                      }, null, 8, _hoisted_23),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("h4", null, _toDisplayString(item.text), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_22)
              ]),
              _: 2
            }, 1032, ["span", "offset"])
          }), 64))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("audio", {
      autoplay: "",
      loop: "",
      hidden: "",
      ref_key: "bgaudio",
      ref: bgaudio
    }, _hoisted_26, 512)
  ]))
}
}

})